<template>
    <div class="lang arabic">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">معلومات المريض</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> الرقم التعريفي للمريض <br>
                                    ( المريض متكرر الزيارة فقط)،</div>
                                <div class="cont"><input type="text" class="input" placeholder="الرقم التعريفي للمريض" v-model="params.ptNo" ref="ptNo"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> الاسم</div>
                                <div class="cont item2">
                                    <input type="text" class="input" placeholder="الأول الاسم" v-model="params.firstName" ref="firstName">
                                    <input type="text" class="input" placeholder="الأخير الاسم" v-model="params.lastName" ref="lastName">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> النوع</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="gender1" id="gender1" value="M" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>ذكر</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="gender2" id="gender2" value="F" v-model="params.gender">
                                            <span class="radio-btn"></span>
                                            <p>أنثى</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>تاريخ الميلاد</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320" v-model="params.birth" ref="birth" maxlength="8"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>الجنسية</div>
                                <div class="cont"><input type="text" class="input" v-model="params.national" ref="national"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> اللغة</div>
                                <div class="cont"><input type="text" class="input" v-model="params.language" ref="language"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> بلد الإقامة</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  >
                                            <input type="radio" name="country1" id="country1" value="K" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>كوري</p>
                                        </label>
                                        <label  >
                                            <input type="radio" name="country2" id="country2" value="O" v-model="params.countryGubun">
                                            <span class="radio-btn"></span>
                                            <p>غير ذلك</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">العنوان في البلد الأم</div>
                                <div class="cont"><input type="text" class="input" v-model="params.addressHome"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>العنوان في كوريا</div>
                                <div class="cont"><input type="text" class="input" v-model="params.address" ref="address"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>المدخلات المطلوبة رقم الهاتف</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.hpNo" ref="hpNo">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">جهة الاتصال في حالات الطوارئ</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">الاسم</div><input type="text" class="input" v-model="params.emergencyNm">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">العلاقة بالمريض</div><input type="text" class="input" v-model="params.emergencyPatRelation">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">رقم الهاتف</div><input type="text" class="input" v-model="params.emergencyHpNo">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>معلومات التأمين</div>
                                <div class="cont"><input type="text" class="input" v-model="params.insuranceInfo" ref="insuranceInfo"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">لموعد تفاصيل</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>الأعراض <br>
                                    (سبب حجز موعد مع الطبيب)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.symptoms" ref="symptoms"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> الخدمات الطبية المطلوبة</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea" v-model="params.mediServiceReq" ref="mediServiceReq"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> التاريخ والوقت المفضلين</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">الأول</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate1" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">{{params.rsvhour1 ? params.rsvhour1 : 'اختر ساعة'}}</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour1 = i, activeselect01()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">{{params.rsvmin1 ? params.rsvmin1 : 'اختر دقيقة'}}</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin1 = i, activeselect02()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">2st</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="preDate2" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply/>
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">{{params.rsvhour2 ? params.rsvhour2 : 'اختر ساعة'}}</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 23" :key="i" @click="[params.rsvhour2 = i, activeselect03()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">{{params.rsvmin2 ? params.rsvmin2 : 'اختر دقيقة'}}</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="javascript:;" class="select-option--btn" v-for="i in 59" :key="i" @click="[params.rsvmin2 = i, activeselect04()]">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">إرفاق تقرير طبي</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadFileName">
                                    <label class="file">
                                        <input type="file" accept=".txt, .pdf, .hwp, .docx, .jpg, .png, .gif" @change="onFileChange($event.target, 'uploadFile')">
                                        <div class="main-button c-gray">إرفاق ملف</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">إرفاق رابط</div>
                                <div class="cont">
                                    <input type="text" class="input" v-model="params.attachLink">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">إرفاق صورة</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;" v-model="params.uploadImgName">
                                    <label class="file">
                                        <input type="file" accept=".jpg, .png, .gif" @change="onFileChange($event.target, 'uploadImg')">
                                        <div class="main-button c-gray">إرفاق ملف</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="javascript:;" class="sub-button c-gray" @click="cancelReservation">تأكيد</a>
                    <a href="javascript:;" class="main-button c-main" @click="simpleAction">إلغاء</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import SlideUpDown from 'vue-slide-up-down';

export default{
    components: {
        VueDatePicker,
        SlideUpDown,
    },
    data() {
        return {
            preDate1: null,
            preDate2: null,
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
            select01: false,
            select02: false,
            select03: false,
            select04: false,

            // 예약 데이터
            params: {
                gender: 'M',
                countryGubun: 'K',
                rsvhour1: '',
                rsvmin1: '',
                rsvhour2: '',
                rsvmin2: ''
            }
        };
    },
    methods: {
        onFileChange(target, str){
            const file = target.files
            if(file.length > 0){
                this.params[str] = file[0]
                this.params[str + 'Name'] = file[0].name
            }
        },
        simpleAction(){
            if (!this.params.ptNo) {
                alert("الرجاء إدخال الرقم التعريفي للمريض.");
                this.$refs.ptNo.focus();
                return false;
            }
            
            if (!this.params.firstName) {
                alert("الرجاء إدخال الأول الاسم");
                this.$refs.firstName.focus();
                return false;
            }
            
            if (!this.params.lastName) {
                alert("الرجاء إدخال الأخير الاسم");
                this.$refs.lastName.focus();
                return false;
            }
            
            if (!this.params.birth) {
                alert("الرجاء إدخال تاريخ الميلاد");
                this.$refs.birth.focus();
                return false;
            } else {
                var birthExp = /^(19[0-9][0-9]|20\d{2})-?(0[0-9]|1[0-2])-?(0[1-9]|[1-2][0-9]|3[0-1])$/;
                if(!birthExp.test(this.params.birth)) {
                    alert("إدخال تاريخ الميلاد غير صحيح.");
                    this.$refs.birth.focus();
                    return false;
                }
            }
            
            if (!this.params.national) {
                alert("الرجاء إدخال الجنسية");
                this.$refs.national.focus();
                return false;
            }
            
            if (!this.params.language) {
                alert("الرجاء إدخال اللغة");
                this.$refs.language.focus();
                return false;
            }
            
            if (!this.params.address) {
                alert("الرجاء إدخال العنوان في كوريا");
                this.$refs.address.focus();
                return false;
            }
            
            if (!this.params.hpNo) {
                alert("الرجاء إدخال المدخلات المطلوبة رقم الهاتف");
                this.$refs.hpNo.focus();
                return false;
            }
            
            if (!this.params.insuranceInfo) {
                alert("الرجاء إدخال معلومات التأمين");
                this.$refs.insuranceInfo.focus();
                return false;
            }
            
            if (!this.params.symptoms) {
                alert("الرجاء إدخال الأعراض");
                this.$refs.symptoms.focus();
                return false;
            }
            
            if (!this.params.mediServiceReq) {
                alert("الرجاء إدخال الخدمات المطلوبة.");
                this.$refs.mediServiceReq.focus();
                return false;
            }
            
            if (!this.preDate1) {
                alert("الرجاء إدخال تاريخ الحجز الأول");
                return false;
            }
            
            if (!this.params.rsvhour1) {
                alert("الرجاء إدخال تاريخ الحجز الأول");
                return false;
            }
            
            if (!this.params.rsvmin1) {
                alert("الرجاء إدخال تاريخ الحجز الأول");
                return false;
            }
            
            if (!this.preDate2) {
                alert("الرجاء إدخال تاريخ الحجز الثاني");
                return false;
            }
            
            if (!this.params.rsvhour2) {
                alert("الرجاء إدخال تاريخ الحجز الثاني");
                return false;
            }
            
            if (!this.params.rsvmin2) {
                alert("الرجاء إدخال تاريخ الحجز الثاني");
                return false;
            }

            this.params.rsvDat1 = this.preDate1.toISOString().split('T')[0]
            this.params.rsvDat2 = this.preDate2.toISOString().split('T')[0]
            this.params.rsvhour1 = ('0' + (this.params.rsvhour1)).slice(-2);
            this.params.rsvhour2 = ('0' + (this.params.rsvhour2)).slice(-2);
            this.params.rsvmin1 = ('0' + (this.params.rsvmin1)).slice(-2);
            this.params.rsvmin2 = ('0' + (this.params.rsvmin2)).slice(-2);
            const urlParam = new URLSearchParams(this.params).toString();
            
            const formData = new FormData();

            // 기존 params의 내용 (파일 외의 다른 데이터) 추가
            Object.keys(this.params).forEach(key => {
                if (key !== 'uploadFile' && this.params[key] !== null) {
                    formData.append(key, this.params[key]);
                }
            });
            if (this.params.uploadFile) {
                formData.append('uploadFile', this.params.uploadFile);
            }

            const param = {langCd: this.$store.getters.getLang}
            this.axios.post(this.api.glb.reservation, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params: param
            })
            .then(response => {
                const data =response.data
                if (data.result == "success") {
					alert("تمت معالجة طلب الحجز.");
					// location.href = `/${this.$store.getters.getLang}/main`;
				} else {
					alert("فشل طلب الحجز..");
					return false;
				}
            }).catch(err => {
                alert('오류가 발생했습니다. 다시 시도해주시길 바랍니다.')
            });
        },
        cancelReservation(){
            if(confirm("Do you really want to cancel?")){
                location.href = `/${this.$store.getters.getLang}/main`;
            }
        },
        activeselect01() {
            this.select01 = !this.select01;
        },
        activeselect02() {
            this.select02 = !this.select02;
        },
        activeselect03() {
            this.select03 = !this.select03;
        },
        activeselect04() {
            this.select04 = !this.select04;
        },
    },
    mounted() {
        
    },
}
</script>
